import { render } from "./TokenPriceChart.vue?vue&type=template&id=1702e87a&scoped=true"
import script from "./TokenPriceChart.vue?vue&type=script&lang=js"
export * from "./TokenPriceChart.vue?vue&type=script&lang=js"

import "./TokenPriceChart.vue?vue&type=style&index=0&id=1702e87a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702e87a"]])

export default __exports__